import { defineMessages } from "react-intl";

const messages = defineMessages({
  addField: {
    id: "settings.pinnedFields.addField",
    defaultMessage: "Add field",
    description: "Add field button title",
  },
  description: {
    id: "settings.pinnedFields.description",
    defaultMessage:
      "Select which fields to pin, their order, and visibility across the organization.",
    description: "Description of settings pinned fields page",
  },
  details: {
    id: "settings.pinnedFields.details",
    defaultMessage: "Details",
    description: "Details section title",
  },
  enableFor: {
    id: "settings.pinnedFields.enableFor",
    defaultMessage: "Enable for",
    description: "Enable for label",
  },
  engagement: {
    id: "settings.pinnedFields.engagement.title",
    defaultMessage: "Engagement info",
    description: "Engagement info title",
  },
  engagementInfo: {
    id: "settings.pinnedFields.engagement.info.label",
    defaultMessage:
      "Show Last Contact value as well as alerts for when a record is out of frequency or has an upcoming activity.",
    description: "Engagement Info",
  },
  manage: {
    id: "settings.pinnedFields.manager",
    defaultMessage: "Manage",
    description: "Manage button",
  },
  pinFor: {
    id: "settings.pinnedFields.pinFor",
    defaultMessage: "Pin For",
    description: "Pin for description",
  },
  quickActions: {
    id: "settings.pinnedFields.quickActions.title",
    defaultMessage: "Quick actions",
    description: "Quick actions title",
  },
  quickActionsInfo: {
    id: "settings.pinnedFields.quickActions.info.label",
    defaultMessage: "Show action buttons that display at the bottom of record preview.",
    description: "Quick Actions Info",
  },
  remove: {
    id: "settings.pinnedFields.remove",
    defaultMessage: "Remove",
    description: "Remove pinned field button",
  },
  setByAdmin: {
    id: "settings.pinnedFields.visibility.tooltip",
    defaultMessage: "Set by your admin",
    description: "Tooltip message if field is set by admin",
  },
  title: {
    id: "settings.pinnedFields.title",
    defaultMessage: "Pinned Fields",
    description: "Title of settings pinned fields page",
  },
});

export default messages;
